/**
 * Application target location. Multi-state UI is frozen; PA-only development.
 */
export const TARGET_LOC = 'US-PA';

export const PA_BOUNDS = [-80.55, 39.68, -74.55, 42.35];
